'use strict';
module.exports = function (useSourceMap) {
    var list = [];
    list.toString = function toString() {
        return this.map(function (item) {
            var content = cssWithMappingToString(item, useSourceMap);
            if (item[2]) {
                return '@media '.concat(item[2], '{').concat(content, '}');
            }
            return content;
        }).join('');
    };
    list.i = function (modules, mediaQuery) {
        if (typeof modules === 'string') {
            modules = [[
                    null,
                    modules,
                    ''
                ]];
        }
        var alreadyImportedModules = {};
        for (var i = 0; i < this.length; i++) {
            var id = this[i][0];
            if (id != null) {
                alreadyImportedModules[id] = true;
            }
        }
        for (var _i = 0; _i < modules.length; _i++) {
            var item = modules[_i];
            if (item[0] == null || !alreadyImportedModules[item[0]]) {
                if (mediaQuery && !item[2]) {
                    item[2] = mediaQuery;
                } else if (mediaQuery) {
                    item[2] = '('.concat(item[2], ') and (').concat(mediaQuery, ')');
                }
                list.push(item);
            }
        }
    };
    return list;
};
function cssWithMappingToString(item, useSourceMap) {
    var content = item[1] || '';
    var cssMapping = item[3];
    if (!cssMapping) {
        return content;
    }
    if (useSourceMap && typeof btoa === 'function') {
        var sourceMapping = toComment(cssMapping);
        var sourceURLs = cssMapping.sources.map(function (source) {
            return '/*# sourceURL='.concat(cssMapping.sourceRoot).concat(source, ' */');
        });
        return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
    }
    return [content].join('\n');
}
function toComment(sourceMap) {
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
    var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,'.concat(base64);
    return '/*# '.concat(data, ' */');
}